<app-side-insight [selectedDeveloperName]='selectedDeveloperName' [selectedDate]="selectedDate"
  [showInsight]='showInsight' [navigateTo]="navigateTo" (navCloseClick)='closeInsight()'>
</app-side-insight>

<div class="rankings-content-section">
  <div class="rankings-main-content">
    <div class="right-content rankings {{currentConfig?.key}}">
      <div class="main-content" [ngClass]="{'loading': loading, 'loadingData': loadingData}">
        <div
          class="d-flex justify-content-between rankings-heading rankings-header-level-1 flex-column flex-md-row blend-hero">
          <div class='d-flex flex-wrap align-items-center justify-content-between w-100'>
            <div class='rankings-header'>
              <h2 class="rankings-heading-title d-lg-block">
                {{currentConfig?.heading}}
              </h2>
              <div class="rankings-heading-subtitle">
                {{currentConfig?.subHeading}}
              </div>
            </div>
            <div class="d-flex flex-column kyd-buttons">
              <a class="btn btn-primary" href="https://www.pixalate.com/know-your-developer" target="_blank">What Is
                Know Your
                Developer™ <i class="fa fa-chevron-right ml-1"></i></a>
              <a class="btn btn-primary"
                href="https://www.pixalate.com/pixalate-know-your-developer-methodology-download" target="_blank">Know
                Your Developer™
                Methodology <i class="fa fa-chevron-right ml-1"></i></a>
            </div>
          </div>
          <video class="blend-video" autoplay muted loop playsinline>
            <source src="/assets/videos/animated-sky-looped.mp4" type="video/mp4" />
          </video>
        </div>

        <div class="rankings-heading">
          <div class="disclaimer-content short-disclaimer">
            Disclaimer: Pixalate's Know Your Developer Ratings reflect Pixalate's opinions and proprietary research
            findings, and are not intended to impugn the standing or reputation of any entity, person, or app.
            Classification of an app developer within a particular risk tier does not indicate that the developer, its
            applications, or any associated practices are in violation of any laws or regulations, including COPPA or
            any other global privacy framework. See full disclaimer below.
          </div>
          <div class="ranking-filter">
            <div
              class="filters-container w-100 d-flexalign-items-center justify-content-between flex-column flex-md-row">
              <div class="input-group search-input" (clickOutside)="closeAlgoliaResults()">
                <div class="search-box">
                  <input id="search-box" type="search" [value]="searchBoxState?.query ?? ''"
                    (input)="onQueryChange($event)" (focus)="onFocus()" (blur)="closeAlgoliaResults()"
                    placeholder="Search App Name, Developer Name" autocomplete="off" />
                </div>

                <div class="results-container" [ngClass]="{'invisible': !showAlgoliaResults}">
                  <ng-container *ngIf="hitsState?.hits.length > 0; else noResults;">
                    <ng-container *ngFor="let hit of hitsState?.hits">
                      <div class="d-flex flex-row flex-nowrap align-items-center dropdown-item text-capitalize"
                        (mousedown)="openInsightWithFilter($event, hit.kydDeveloperName)">
                        <img [src]="hit.appIcon | screenshot:hit.appStore:72"
                          onerror="this.src='/assets/icons/icon-72x72-grey.png'" class="mr-2 rounded d-inline"
                          width="50" alt="{{ hit.kydDeveloperName }} Icon" />
                        <div class="d-flex flex-column align-items-start gap-0 mr-auto">
                          <span><b class="title">Developer: </b>{{hit.kydDeveloperName}}</span>
                          <span><b class="title">App Name: </b>{{hit.title}}</span>
                        </div>
                        <risk-severity [risk]="hit.kydOverallRisk"></risk-severity>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #noResults>
                    <div class="d-flex flex-row flex-nowrap align-items-center dropdown-item text-capitalize">
                      <p class="no-results m-0">No results found</p>
                    </div>
                  </ng-template>
                </div>
              </div>

              <app-new-rankings-main-filter-items [currentMainFilterItems]="currentMainFilterItems"
                [selectedGroup]="selectedGroup"
                (selectMainFilterClick)="selectMainFilter($event.mainFilterItem, $event.option)">
              </app-new-rankings-main-filter-items>
            </div>
          </div>
        </div>

        <div class='results-table-cont'>
          <ng-container *ngIf="desktop$ | async">
            <div class='results-table-scroll-cont' [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <table class='results-table' fixed-table-header [ngClass]="{ sortable: currentConfig?.sortable }"
                *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                <thead>
                  <tr>
                    <ng-container *ngFor="let header of rankingGridHeaders; let last = last;">
                      <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                        <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                          <th class="{{header?.key}}" (click)="toggleSort(header)">
                            <app-ranking-gridheader-widget-container [header]="header"
                              [widgetComponent]="header?.headerWidgetComponent" [selectedGroup]="selectedGroup"
                              [isLast]="last">
                            </app-ranking-gridheader-widget-container>
                            <div class="sort-buttons {{header?.sort}}" *ngIf="header?.sortColumnKey">
                              <i class="fa fa-caret-up"></i>
                              <i class="fa fa-caret-down"></i>
                            </div>
                          </th>
                        </ng-container>

                        <ng-template #spacer>
                          <th class="spacer" [style.width]="header?.format">&nbsp;</th>
                        </ng-template>
                      </ng-container>
                    </ng-container>
                  </tr>
                </thead>
                <tbody [ngClass]="{'show-results': !showAnonEmailUnlockForm}">
                  <tr class="table-row-nav"
                    *ngFor="let dataItem of gridData | sortBy:sortHeader?.key:sortHeader?.sort; index as rowIdx"
                    (click)="openInsight(rowIdx, dataItem)">
                    <ng-container *ngFor=" let header of rankingGridHeaders; last as last">
                      <ng-container *ngIf="header?.key !== 'spacer'; else spacer">
                        <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                          <td class="grid-data-item {{header.key}}">
                            <ng-container *ngIf="header?.widgetComponent">
                              <div [ngClass]="{'with-accordion': last}">
                                <app-ranking-widget-container [data]="dataItem" [header]="header"
                                  [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                                  [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup"
                                  (clickEvent)="openInsight(rowIdx, dataItem, $event.key)">
                                </app-ranking-widget-container>
                                <i *ngIf="last" class="fa fa-chevron-right"></i>
                              </div>
                            </ng-container>
                          </td>
                        </ng-container>
                      </ng-container>
                      <ng-template #spacer>
                        <td>&nbsp;</td>
                      </ng-template>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>

          <ng-container *ngIf="!(desktop$ | async)">
            <div class="d-flex flex-column" [ngClass]="{'d-none': noResult}" *ngIf="gridData?.length > 0">
              <ng-container *ngFor="let dataItem of gridData; index as rowIdx">
                <div class="result-item-cont p-3 mx-0" *ngIf="currentConfig?.gridHeaders as rankingGridHeaders">
                  <ng-container *ngFor="let header of rankingGridHeaders">
                    <ng-container *ngIf="!header.hidden && gridData[0][header.key] &&
                         (currentConfig?.notHideDataIfNA || gridData[0][header.key] !== 'N/A')">
                      <div class="d-flex align-items-center justify-content-between result-item"
                        (click)="openInsight(rowIdx, dataItem)">
                        <span class="name">{{ header.label }}</span>
                        <div class="value {{ header?.key }}">
                          <app-ranking-widget-container [data]="dataItem" [header]="header"
                            [reportId]="currentConfig?.reportId" [widgetComponent]="header.widgetComponent"
                            [key]="header?.key" [format]="header.format" [selectedGroup]="selectedGroup"
                            (clickEvent)="openInsight(rowIdx, dataItem, $event.key)">
                          </app-ranking-widget-container>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>

          <div class="load-more">
            <button [hidden]="!showLoadMore" class="btn btn-primary" (click)="loadMore()">
              <span>load more</span>
            </button>
            <button [hidden]="!showLoadingMore" class="btn btn-primary"> loading more results...</button>
            <span *ngIf="!loadingData && noResult" class="d-table mt-4 mx-auto">No results
              found.</span>
          </div>

          <div class="loader mt-5 mx-auto" data-loader="circle-side"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="disclaimer-content full-disclaimer" id="full-disclaimer">
  <p>
    <b>Disclaimer:</b> Pixalate’s Mobile Application Know Your Developer Ratings (“KYD”) reflect Pixalate’s opinions
    that Pixalate believes may be useful to regulators, platforms, advertisers, researchers, and others in the digital
    media industry. Any data shared is grounded in Pixalate’s proprietary technology and analytics, which Pixalate is
    continuously evaluating and updating. Any references to outside sources should not be construed as endorsements,
    affiliations, or associations with any third-parties. Pixalate is sharing this data not to impugn the standing or
    reputation of any entity, person or app, but, instead, to report research findings and trends pertaining to the time
    period studied.
  </p>

  <p>It is important to note however, that classification of a mobile application developer (“app developer”) within a
    particular risk tier does not mean that the app developer, its applications, or any associated practices are in
    violation of any laws or regulations, including the Children’s Online Privacy Protection Act (COPPA) or any other
    global privacy framework. Further, the app(s) of an app developer(s) that appear(s) to be directed to children
    (e.g., users under 13 years of age, as defined by the COPPA Rule) does not mean that any such app, or its operator,
    is failing to comply with the COPPA Rule.
  </p>

  <p>Pixalate’s determinations are based on a proprietary methodology that incorporates a combination of signals and
    automated processes. Additionally, with respect to app developers that appear to have characteristics that, in
    Pixalate’s opinion, may trigger related privacy law or regulatory compliance obligations and/or risk, such
    assertions reflect Pixalate’s opinions i.e., they are neither facts nor guarantees. While Pixalate endeavours to
    apply rigorous standards in compiling this KYD, no assurances or guarantees can be, or are, made as to the accuracy
    or completeness of any classification. This article/expose, including all content set forth herein–constitutes
    Pixalate “Materials” under Pixalate’s Terms of Use, and is licensed subject to–and conditioned expressly
    upon–compliance with each of the applicable terms and conditions of such Pixalate Terms of Use. <i>Per the MRC,
      “'Fraud' is not intended to represent fraud as defined in various laws, statutes and ordinances or as
      conventionally
      used in U.S. Court or other legal proceedings, but rather a custom definition strictly for advertising measurement
      purposes. Also per the MRC, “‘Invalid Traffic’ is defined generally as traffic that does not meet certain ad
      serving
      quality or completeness criteria, or otherwise does not represent legitimate ad traffic that should be included in
      measurement counts. Among the reasons why ad traffic may be deemed invalid is it is a result of non-human traffic
      (spiders, bots, etc.), or activity designed to produce fraudulent traffic.”.</i>
  </p>

  <p>Apple and the Apple logo are trademarks of Apple Inc; Google, Google Ad Exchange, the brand “Google Play,” its
    logos, and other Google logos are trademarks of Google LLC. These companies are not affiliated with, nor do they
    endorse or sponsor, any products, data, content, reports, materials or services associated with Pixalate. Any other
    brand logos, names, or trademarks not explicitly mentioned herein – but otherwise mentioned, displayed, or used in
    any of Pixalate’s materials, including this report – are the property of their respective owners.
  </p>

  <p>© 2026 Pixalate, Inc.</p>

</div>

<app-rankings-anon-form-v2 [formTitle]="currentConfig.title"
  (formSubmit)="toggleTableBlur()"></app-rankings-anon-form-v2>